import { useReactiveVar } from '@apollo/client/react/hooks';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react';
import { snackBarAlerts } from '../apollo/reactive-variables/alerts';
import useSnackBars from '../hooks/useSnackBars';
import SNACKBAR_ALERT_CLASS_NAME from '../theme/constants/alert';

const SnackbarAlert = () => {
  const alerts = useReactiveVar(snackBarAlerts);
  const { deleteFromAlert } = useSnackBars();

  return (
    <>
      {alerts.map((alert) => (
        <Snackbar
          key={alert.id}
          open={alert.open}
          autoHideDuration={5000}
          onClose={() => deleteFromAlert(alert.id)}
          TransitionComponent={(props) => <Slide {...props} direction="left" />}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            className={SNACKBAR_ALERT_CLASS_NAME}
            onClose={() => deleteFromAlert(alert.id)}
            severity={alert.severity || 'info'}
            color={alert.color || 'text'}
            variant="filled"
            iconMapping={{
              success: (
                <CheckCircleIcon
                  sx={{
                    fontSize: 20,
                    color: 'success.main',
                  }}
                />
              ),
            }}
          >
            {alert.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default SnackbarAlert;
